import { useCallback, useEffect, useRef, useState } from 'react';

const TOAST_DURATION = 2200;

interface UseToastResult {
    message: string;
    visible: boolean;
    showToast: (text: string) => void;
}

/** Показывает короткое уведомление внизу экрана и сам его прячет. */
export const useToast = (duration: number = TOAST_DURATION): UseToastResult => {
    const [message, setMessage] = useState('');
    const [visible, setVisible] = useState(false);

    const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

    const showToast = useCallback(
        (text: string): void => {
            setMessage(text);
            setVisible(true);

            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => setVisible(false), duration);
        },
        [duration],
    );

    useEffect(() => () => clearTimeout(timerRef.current), []);

    return { message, visible, showToast };
};